export default __webpack_public_path__ + "static/media/infoIcon.2e8e028d.svg";